<template>
  <div>
    <!-- selectedCompanies:{{ selectedCompanies }} -->
    <d-table
      v-if="tableReady"
      :searchAfterCompleted="true"
      minSearchLength="6"
      tableName="shipments"
      :data_object="data_object"
      :getFreshData="true"
      :table_title="tableTitle"
      :linkClick="linkClick"
      :link="link"
      :breakpoint="0"
      :onDataReceived="onDataReceived"
      :getRowClass="getRowClass"
      :coloredFields="coloredFields"
      :getItemColor="getItemColor"
      :itemsPerPage="50"
      :filterCondition="filterCondition"
      :searchableColumns="searchableColumns"
      :numericFields="numericFields"
      :hasSearch="true"
      :hasAdvancedSearch="true"
      ref="dTable"
      :key="tableKey"
      :serverPagination="true"
      :remoteSearch="false"
      :showGroupBy="true"
      sortBy="shipment_id"
      :sortDesc="true"
      v-bind="vBind"
      :noDelete="noDelete"
      :toolBarControls="toolBarControls"
      :toolbarRight="true"
      :defaultTabCaption="defaultTabCaption"
      :columnTool="true"
      :defaultTabColor="defaultTabColor"
      :noTabs="noTabs"
      :noGroups="noGroups"
      :mobileViewTemplate="mobileViewTemplate"
      deleteId="sid"
      :remoteSearchFields="remoteSearchFields"
    />
    <!-- <v-alert
      class="ma-4"
      dismissible
      timeout="3000"
      v-if="successMessage != '' && !noAlert"
      type="success"
    >
      {{ successMessage }}
    </v-alert> -->
    <v-snackbar
      v-if="successMessage != '' && !noAlert"
      v-model="successMessage"
      :timeout="3000"
      color="success"
    >
      {{ successMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="successMessage = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-alert
      class="ma-4"
      timeout="3000"
      dismissible
      v-if="errorMessage != '' && errorMessage"
      type="error"
    >
      {{ errorMessage }}
    </v-alert>
  </div>
</template>
<script>
import DTable from "../components/Table";
import axios from "axios";
import * as fun from "../plugins/common";

export default {
  components: { DTable },
  props: {
    searchInput: String,
  },
  data() {
    return {
      tblClass: "",
      successMessage: "",
      errorMessage: "",
      tableKey: 0,
      tableReady: false,
      getFreshData: true,
      link: {
        field: "shipment_id",
        name: "shipment",
      },
      latestDate: null,
      data_object: {
        object_name: "shipments",
        schema_name: "v_shipments",

        // delete_object_name: "shipments",
        date_fields: ["latest_date"],
        qry_to_match: {},

        // mobileBreakpoint: 0,
        all_records: true,
        additional_data: [
          { obj_name: "service_type" },
          { obj_name: "lead_status" },
          { obj_name: "stage" },
          { obj_name: "company" },
          {
            obj_name: "employee",
            qry: {
              _id: this.$root.user_id,
            },
          },
        ],

        item_key: "shipment_id",
        table_title: "Shipments",
        hasSearch: true,
      },
      coloredFields: ["service_type", "booked", "lead_status", "company_name"],
      serviceTypes: [],
      leadStatus: [],
      company: [],
      stages: [],
      filterTabs: [],
      originalRecords: [],
      searchableColumns: [],
      vBind: {},
      selectRecords: false,
      plansSelected: [],
      toolBarControls: [],
      showSalesPersonList: 0,
      showCompaniesList: 0,
      selectedCompanies: [],
      showAssignButton: false,
      salesPerson: "",
      currentUser: "",
      noDelete: true,
      date: "",
      // defaultTabCaption: "All Future Shipments",
      defaultTabColor: "success",
      showSalesClicked: false,
      showCompaniesClicked: false,
      btnLabel: "Assign Sales Persons",
      btnLabelCompanies: "Assign Companies",
      // tableTitle: "Future Shipments",
      customerId: null,
      noTabs: false,
      noGroups: false,
      mobileViewTemplate: true,
      dateQry: null,
      employeeList: [],
      numericFields: ["shipment_id"],
      remoteSearchFields: [
        "first_name",
        "last_name",
        "full_name",
        "email",
        "customer_name",
        "mobile_phone",
        "shipment_id",
        "lead_id",
      ],
    };
  },
  mounted() {
    // this.updateShipmentDetails();
    this.mount();
  },

  methods: {
    mount() {
      var that = this;
      this.date = fun.formatDate(new Date(), true, null, true);
      this.latestDate = { $gte: this.date };
      this.getQry();
      this.$root.$on("customBtnClick", (f) => {
        if (f.btn == "assignSales") {
          that.showSales();
        }
        if (f.btn == "archive") {
          that.archive(f);
        }
        if (f.btn == "assignCompanies") {
          that.showCompanies();
        }
      });
      this.$root.$on("tableFilterChanged", (t) => {
        // console.log(t);
        if (t.tableName == "shipments") {
          if (t.currentFilter == 1 || t.currentFilter == 0) {
            // that.showAssignButton = true;
            // t.toolBarControls[0]["v-bind"].hidden = false;
          } else {
            // that.showAssignButton = false;
            // t.toolBarControls[0]["v-bind"].hidden = true;
          }
        }
      });
      //tableFilterChanged

      if (this.$root.customerId) {
        // this.customerId = this.$root.store.userData._id;
        // this.data_object.qry = { customer: this.customerId };
        this.data_object.qry = {};
        this.data_object.qry.customer_id = this.$root.customerId.$oid;
        this.data_object.id_fields = ["customer_id", "sid"];
        this.data_object.deleteId = "sid";

        this.noTabs = true;
        this.noGroups = true;
      } else {
        this.data_object.additional_delete_objects = [
          { table_name: "shipment", id_name: "_id" },
        ];
        // this.data_object.aggregate = {
        //   local_collection: "shipment",
        //   pipeline_name: "v_shipments",
        //   pipeline: [
        //     {
        //       $limit: 10,
        //     },
        //   ],
        // };
      }
      this.tableReady = true;
      this.$root.$on("tableSelectionChanged", (t) => {
        if (!t.selectDelete) {
          that.plansSelected = t.selected;
        }
      });
      this.toolBarControls = [];
      if (!this.$root.customerId) {
        this.toolBarControls = [
          {
            comp: "v-btn",
            id: "assignSales",
            default: false,
            "v-bind": {
              color: "info",
              text: true,

              // hidden: !this.showAssignButton,
              icon: "mdi-account-check",
              "input-value": "Assign Sales",
            },
          },
          {
            comp: "v-combo",
            id: "salesPersons",
            default: false,
            hidden: !this.showSalesPersonList,
            model: this.salesPerson,
            "v-bind": {
              objName: "v_sales_person",
              itemText: "full_name",
              itemValue: "_id",
              returnObject: true,
              onValueChange: this.assignSales,
              clearable: true,
            },
          },
          {
            comp: "v-btn",
            id: "assignCompanies",
            default: false,
            "v-bind": {
              color: "info",
              text: true,

              hidden: this.company.length == 1,
              icon: "mdi-compare-horizontal",
              "input-value": "Assign Companies",
            },
          },
          {
            comp: "v-combo",
            id: "companies",
            default: false,
            hidden: !this.showCompaniesList,
            model: this.selectedCompanies,

            "v-bind": {
              objName: "company",
              itemText: "company_name",
              itemValue: "_id",
              onValueChange: this.assignCompanies,
              multiple: true,
              returnObject: true,
              clearable: true,
            },
          },
        ];
      }
      this.toolBarControls.push({
        comp: "v-btn",
        id: "archive",
        "v-bind": {
          color: "warning",
          text: true,
          icon: "mdi-archive",
          "input-value": "View Past Shipments",
        },
      });
    },
    updateShipmentDetails() {
      axios
        .post(this.serverURL + "/update_shipment_details", null, {
          withCredentials: true,
        })
        .then((r) => {
          this.mount();
        });
    },
    getQry() {
      var that = this;
      this.data_object.qry = this.$root.getQry();

      this.dateQry = {
        $or: [
          { latest_date: { $exists: false } },
          { latest_date: { $eq: null } },
          { latest_date: { $eq: "None" } },
          { latest_date: this.latestDate },
        ],
      };
      // this.data_object.qry_to_match = fun.clone(this.dateQry);
      // this.data_object.qry.$and.push(this.dateQry);
      this.currentUser = this.$root.store.userData;
      if (
        this.currentUser.company?.length &&
        Array.isArray(this.currentUser.company)
      ) {
        this.data_object.qry.$and.push({
          company_name: {
            $in: this.currentUser.company.map((r) => {
              return r.company_name;
            }),
          },
        });
      }

      var permittedActions = this.$root.store.permittedActions;
      // var filterJobs = false;
      // var noBooked = false;
      // var filterCompany = false;
      if (permittedActions) {
        permittedActions.forEach((a) => {
          // if (a.filter_jobs && !this.$root.isAdmin) {
          //   filterJobs = true;
          //   // .sales_person_email = this.currentUser;
          // }
          if (a.bulk_delete) {
            this.noDelete = false;
          }
          if (a.shipment_filter) {
            a.shipment_filter.forEach((f) => {
              Object.keys(f).forEach((k) => {
                if (Array.isArray(f[k]) && f[k].length) {
                  let q = {};
                  q[k] = { $in: f[k] };
                  this.data_object.qry.$and.push(q);
                }
              });
            });
          }
          // if (a.hide_booked_jobs && !this.$root.isAdmin) {
          //   noBooked = true;
          // }
          // if (a.only_assigned_company) {
          //   filterCompany = true;
          // }
        });
      }
      // var noBookedQry = {
      //   $or: [
      //     { booked: 0 },
      //     {
      //       booked: { $exists: false },
      //     },
      //   ],
      // };

      // if (filterJobs) {
      //   // var booked = fun.clone(this.data_object.qry.booked);
      //   this.data_object.qry = {
      //     $and: [
      //       this.dateQry,
      //       {
      //         $or: [
      //           { "shipment_detail.sales_person._id": this.$root.user_id },
      //           { "agent.contact.email": this.currentUser },
      //         ],
      //       },
      //     ],
      //   };
      //   if (noBooked) {
      //     this.data_object.qry.$and.push(noBookedQry);
      //   }
      // } else {
      //   if (noBooked) {
      //     this.data_object.qry = {
      //       $and: [this.dateQry, noBookedQry],
      //     };
      //   } else {
      //     this.data_object.qry = this.dateQry;
      //   }
      // }
      if (this.$root.filteredCompanies()) {
        if (!this.data_object.id_fields) {
          this.data_object.id_fields = [];
        }
        this.data_object.id_fields.push("_id");
        // var list_of_company_ids = this.$root.store.userData.company.map(
        //   (c) => c._id["$oid"]
        // );
        // var filterCompanyQry = {
        //   $expr: {
        //     $in: [
        //       { $toString: "$shipment_detail.company._id" },
        //       this.$root.filteredCompanies(),
        //     ],
        //   },
        //   // "shipment_detail.company._id": {
        //   //   $in: this.$root.filteredCompanies(),
        //   // },
        // };
        // if (!this.data_object.qry.$and) {
        //   this.data_object.qry.$and = [];
        // }
        // this.data_object.qry.$and.push(filterCompanyQry);
      }
      if (!this.data_object.qry.$and?.length) {
        this.data_object.qry = {};
      }
    },
    linkClick: function(item) {
      if (!item.customer_name) {
        item.customer_name = item.first_name + " " + item.last_name;
      }
      this.$root.addResentTab(item);
    },
    showCompanies(completed) {
      if (!this.showCompaniesClicked) {
        this.$refs.dTable.selected = [];
        this.$refs.dTable.select = !this.$refs.dTable.select;
        this.selectRecords =
          this.$refs.dTable.select && !this.$refs.dTable.selectDelete;

        this.btnLabelCompanies =
          this.selectRecords && this.btnLabelCompanies == "Assign Companies"
            ? "Please select records to assign"
            : "Assign Companies";
        this.toolBarControls[2]["v-bind"][
          "input-value"
        ] = this.btnLabelCompanies;
      } else {
        var cmb = this.toolBarControls[3];
        if (!this.selectedCompanies.length) {
          return;
        }
        this.$root.$confirm
          .open("Multiply", "Multiply Leads for selected companies?", {
            color: "green",
          })
          .then((confirm) => {
            if (confirm) {
              var ids = [];
              this.plansSelected.forEach((r) => {
                ids.push(r.sid);
              });

              this.multiplyLeads(ids);
            }
          });
      }
      if (!completed) {
        this.showCompaniesClicked = true;
      }

      this.toolBarControls[3].hidden = !this.showCompaniesList;
    },
    showSales() {
      // console.log("assign Sales");
      this.showSalesClicked = true;
      this.$refs.dTable.selected = [];
      this.$refs.dTable.select = !this.$refs.dTable.select;
      this.selectRecords =
        this.$refs.dTable.select && !this.$refs.dTable.selectDelete;

      this.btnLabel =
        this.selectRecords && this.btnLabel == "Assign Sales Persons"
          ? "Please select records to assign"
          : "Assign Sales Persons";
      this.toolBarControls[0]["v-bind"]["input-value"] = this.btnLabel;
      this.toolBarControls[1].hidden = !this.showSalesPersonList;
      //plansSelected
    },
    archive() {
      var btn = null;
      // this.data_object.qry = {};
      if (this.$root.customerId) {
        btn = this.toolBarControls[0]["v-bind"];
        // if (this.$root.customerId) {
        this.data_object.qry.customer_id = this.$root.customerId.$oid;
        this.data_object.id_fields = ["customer_id"];
        // }
      } else {
        btn = this.toolBarControls[2]["v-bind"];
        var spBtn = this.toolBarControls[0]["v-bind"];
        var sp = this.toolBarControls[1]["v-bind"];
      }
      var caption = btn["input-value"];
      var hidden = false;
      // var shipmentBtn =
      //   this.toolBarControls.length > 1
      //     ? this.toolBarControls[4]["v-bind"]
      //     : this.toolBarControls[0]["v-bind"];
      // var shipmentCaption = shipmentBtn["input-value"];

      // if (shipmentCaption == "View Past Shipments") {
      //   shipmentCaption = "View Future Shipments";
      //   shipmentBtn.icon = "mdi-truck-delivery";
      //   shipmentBtn.color = "success";
      //   this.latestDate = { $lt: this.date };

      //   this.defaultTabCaption = "All Past Shipments";
      //   this.tableTitle = "Past Shipments";
      //   this.defaultTabColor = "warning";
      //   hidden = true;
      // } else {
      //   // this.tableTitle = "Future Shipments";
      //   shipmentCaption = "View Past Shipments";
      //   shipmentBtn.icon = "mdi-archive";
      //   shipmentBtn.color = "warning";
      //   this.latestDate = { $gte: this.date };
      //   // this.data_object.qry = {
      //   //   latest_date: { $gte: this.date },
      //   // };
      //   this.defaultTabCaption = "All Future Shipments";
      //   // this.tableTitle = "Future Shipments";
      //   this.defaultTabColor = "success";
      //   hidden = false;
      // }
      if (spBtn) {
        spBtn["hidden"] = hidden;
      }

      this.getQry();
      // shipmentBtn["input-value"] = shipmentCaption;
      this.tableKey = !this.tableKey;
    },
    assignCompanies(cmb) {
      this.selectedCompanies = cmb.value;
    },
    assignSales(cmb) {
      // console.log(cmb.value);
      if (this.showSalesPersonList) {
        if (cmb.value) {
          var employee = this.employeeList[0];

          // var sp =
          //   employee.contact.first_name + " " + employee.contact.last_name;
          var confirmLabel = cmb.value
            ? "Confirm assigning " +
              this.plansSelected.length +
              " record(s) to " +
              cmb.value.full_name +
              "?"
            : "Confirm removing sales person from " +
              this.plansSelected.length +
              " record(s)?";
          this.$root.$confirm
            .open("Delete", confirmLabel, {
              color: "red",
            })
            .then((confirm) => {
              if (confirm) {
                var ids = [];
                this.plansSelected.forEach((r) => {
                  ids.push(r.sid);
                });
                var spObj = cmb.value;
                this.updateSalesPersons(spObj, ids);
              }
            });
        }
      }
    },
    updateSalesPersons(v, ids) {
      var that = this;
      var metadata = {
        object_name: "shipment",
        ids: ids,
      };
      var data = {
        metadata: metadata,
        model: {
          "shipment_detail.sales_person": v || {},
          stage: "assigned_leads",
        },
      };

      axios
        .post(this.serverURL + "/update_many", data, {
          withCredentials: true,
        })
        .then((r) => {
          // console.log(r);
          // this.$refs.dTable.select = false;
          this.$refs.dTable.selected = [];
          // this.$refs.dTable.currentFilter = 1;
          this.$refs.dTable.refresh();

          this.showSales();
          this.successMessage =
            r.data + ": " + ids.length + " shipments assigned";
        });
    },

    multiplyLeads(ids) {
      var that = this;
      var data = {
        company_array: this.selectedCompanies,
        id_array: ids,
      };

      axios
        .post(this.serverURL + "/multiply_leads", data, {
          withCredentials: true,
        })
        .then((r) => {
          this.$refs.dTable.selected = [];

          this.$refs.dTable.refresh();
          this.showCompaniesClicked = false;
          this.showCompanies(true);
          var totalShipments = ids.length * this.selectedCompanies.length;
          this.successMessage = totalShipments + " new shipments created";
        });
    },
    getItemColor(value, field) {
      var color = "black";
      switch (field) {
        case "service_type":
          this.serviceTypes.forEach((s) => {
            if (s.service_type == value) {
              if (s.color && s.color.replace) {
                // if (!isItem) {
                //   color = s.color.replace("#", "");
                // } else {
                color = s.color;
                // }
              } else {
                color = "";
              }
            }
          });
          // if (!isItem) {
          //   return "color-" + color;
          // } else {
          return color;
        // }

        case "lead_status":
          this.leadStatus.forEach((s) => {
            if (s.status == value) {
              if (s.color && s.color.replace) {
                // if (!isItem) {
                //   color = s.color.replace("#", "");
                // } else {
                color = s.color;
                // }
              } else {
                color = "black";
              }
            }
          });
          return color;
        case "company_name":
          this.company.forEach((s) => {
            if (s.company_name == value) {
              if (s.color && s.color.replace) {
                // if (!isItem) {
                //   color = s.color.replace("#", "");
                // } else {
                color = s.color;
                // }
              } else {
                color = "black";
              }
            }
          });
          return color;
        default:
          break;
      }
      // if (field == "service_type") {
      //   return this.getServiceColor(value, true);
      // }
      // if (field == "booked") {
      //   return value == "Booked" ? "green" : "black";
      // }
      // if (field == "lead_status") {
      //   return value == "Booked" ? "green" : "black";
      // }
    },

    getServiceColor(serviceType, isItem) {
      var color = "";
      this.serviceTypes.forEach((s) => {
        if (s.service_type == serviceType) {
          if (s.color && s.color.replace) {
            if (!isItem) {
              color = s.color.replace("#", "");
            } else {
              color = s.color;
            }
          } else {
            color = "";
          }
        }
      });
      if (!isItem) {
        return "color-" + color;
      } else {
        return color;
      }
    },
    getStage(d) {
      this.stages.forEach((s) => {
        if (s.old_statuses) {
          if (!Array.isArray(s.old_statuses)) {
            s.old_statuses = [s.old_statuses];
          }
          s.old_statuses.forEach((st) => {
            if (st.toLowerCase() == d.lead_status.toLowerCase()) {
              d.stage = s.stage;
            }
          });
        }
      });
      return d;
    },
    getLocation(rec, s, isOrig) {
      var locations = rec.address;
      var location;

      var nStops = s.shipment_stop.length;
      var stopNum = isOrig ? 1 : nStops;
      s.shipment_stop.forEach((st, i) => {
        if (parseInt(st.stop_number) == stopNum) {
          location = locations.filter((l) => {
            return l.address_type == st.address_label;
          });
          if (location.length) {
            location = location[0].location;
          }
        }
      });
      if (
        location &&
        location.address &&
        location.address.geo &&
        location.address.geo.location
      ) {
        return location.address.geo.location.address;
      }
    },
    onDataReceived(data) {
      this.vBind = data.schema["v-bind"];
      this.serviceTypes = data.additional_model.service_type;
      this.leadStatus = data.additional_model.lead_status;
      this.company = data.additional_model.company;
      this.employeeList = data.additional_model.employee;
      if (this.company.length == 1) {
        data.schema.properties["company_name"].hideInTable = true;
      }
      this.stages = data.additional_model.stage;

      data.model.forEach((d) => {
        d._id = fun.guid();
        // d = this.getStage(d);
        // if(!d.stage){

        // }

        if (!d.sales_person) {
          if (!d.booked) {
            d.stage = "unassigned_leads";
          }
        } else {
          if (!d.stage) {
            d.stage = "assigned_leads";
          }
        }
      });
      var classes = "";
      this.serviceTypes.forEach((s) => {
        try {
          if (s.color && s.color.replace) {
            var className = "color-" + s.color.replace("#", "");
            var classCss = "border: 5px solid " + s.color + ";";

            var cl = "\n." + className + " { " + classCss + "}";
            if (classes.indexOf(cl) == -1) {
              classes += cl;
            }
          }
        } catch (error) {
          console.log(error);
        }
      });

      this.$root.dynamicClasses(classes);

      data.table = data.model;
      // delete data.model;

      return data;
    },
  },
  watch: {
    plansSelected() {
      if (this.showSalesClicked) {
        var btnLabel = this.plansSelected.length
          ? "Assign " + this.plansSelected.length + " leads to:"
          : this.btnLabel;
        this.toolBarControls[0]["v-bind"]["input-value"] = btnLabel;
        this.showSalesPersonList = this.plansSelected.length;
        this.toolBarControls[1].hidden = !this.plansSelected.length;
      }
      if (this.showCompaniesClicked) {
        var btnLabelCompanies = this.plansSelected.length
          ? "Assign " + this.plansSelected.length + " leads to:"
          : this.btnLabelCompanies;
        this.toolBarControls[2]["v-bind"]["input-value"] = btnLabelCompanies;
        this.showSalesPersonList = this.plansSelected.length;
        this.toolBarControls[3].hidden = !this.plansSelected.length;
      }
    },
    salesPerson() {
      console.log(this.salesPerson);
    },
  },
};
</script>
<style scoped>
.v-tab {
  background-color: white;
  margin: 1px !important;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  border: solid 1px;
}
</style>
